import { render } from "./Topbar.vue?vue&type=template&id=45a71308"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"
script.render = render

export default script